import { ProductFields } from "@tenforce/product-fields"
import {
    formatFileSize,
    isImage,
} from "../../components/fields/components/attachments/utils"
import env from "../../env"
import { formatDateTimeStringFromISO } from "./dateTimeParsing"

export function convertToProductFieldAttachment(
    attachment: Api.Attachment,
    creator: string | undefined,
    userFormattingSettings: UserMenu.UserFormattingSettings,
): ProductFields.Attachment {
    return {
        id: attachment.Id,
        creator: creator,
        description: attachment.Description,
        fileName: attachment.FileName,
        fileProperties: `${formatDateTimeStringFromISO(
            attachment.CreatedOn,
            userFormattingSettings,
        )} · ${formatFileSize(attachment.FileSize)}`,
        thumbnail: isImage(attachment.FileName)
            ? `${env.applicationPath}/dataapi/Attachments(${attachment.Id})/Thumbnail`
            : "",
        url: `${env.applicationPath}/dataapi/Attachments(${attachment.Id})/$Value`,
    }
}
